import { defineMessages } from 'react-intl';

/**
 * Accessibility strings for the examples column (iframe title, illustration alt text).
 * Use with {@link useIntl} `formatMessage` in the examples section and variant hook.
 */
export const examplesSectionMessages: {
	illustrationAICustomerServiceAgentsCSMTeam: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationAICustomerServiceFormsCSMTeam: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationAutomationRules: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationHelpCenterCustomization: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationKnowledgeBaseOpsTeam: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationKnowledgeBaseServiceTeams: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationRovoServiceAgentsOpsTeam: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationRovoServiceAgentsServiceTeams: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationRovoSupportCompanionCSMTeam: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationUnlimitedAgents: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	incidentsVideoIframeTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	workforceOptimizationVideoIframeTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	incidentsVideoIframeTitle: {
		id: '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title',
		defaultMessage: 'YouTube video player',
		description: 'Accessible title for the incidents Slack integration YouTube embed iframe',
	},
	workforceOptimizationVideoIframeTitle: {
		id: '@atlassian/edition-benefits-modal.examples-section.iframe-title.workforce-optimization',
		defaultMessage: 'Workforce Optimization video',
		description: 'Accessible iframe title for the WFO Premium upsell video pane',
	},
	illustrationHelpCenterCustomization: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.help-center-customization',
		defaultMessage: 'Help Center Customization Illustration',
		description: 'Alt text for the help center customization example image',
	},
	illustrationRovoServiceAgentsServiceTeams: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.rovo-service-agents-service-teams',
		defaultMessage: 'Rovo Service Agents Ops Team Illustration',
		description: 'Alt text for the Rovo Service Agents example image (service teams)',
	},
	illustrationRovoServiceAgentsOpsTeam: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.rovo-service-agents-ops-team',
		defaultMessage: 'Rovo Ops Agent Illustration',
		description: 'Alt text for the Rovo Ops Agent example image',
	},
	illustrationKnowledgeBaseServiceTeams: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.knowledge-base-service-teams',
		defaultMessage: 'Rovo Service Agents Ops Team Illustration',
		description: 'Alt text for the knowledge base example image (service teams)',
	},
	illustrationKnowledgeBaseOpsTeam: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.knowledge-base-ops-team',
		defaultMessage: 'Assets Ops Team Illustration',
		description: 'Alt text for the assets / knowledge example image (ops team)',
	},
	illustrationAutomationRules: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.automation-rules',
		defaultMessage: 'Automation Rules Service Team Illustration',
		description: 'Alt text for the automation rules example image (service and ops teams)',
	},
	illustrationUnlimitedAgents: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.unlimited-agents',
		defaultMessage: 'Unlimited Agents Service Team Illustration',
		description: 'Alt text for the unlimited agents example image (service and ops teams)',
	},
	illustrationAICustomerServiceAgentsCSMTeam: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.ai-customer-service-agents-csm-team',
		defaultMessage: 'AI Customer Service Agents Illustration',
		description: 'Alt text for the AI customer service agents example image (csm teams)',
	},
	illustrationRovoSupportCompanionCSMTeam: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.rovo-support-companion-csm-team',
		defaultMessage: 'Rovo Support Companion Illustration',
		description: 'Alt text for the Rovo Support Companion example image (csm teams)',
	},
	illustrationAICustomerServiceFormsCSMTeam: {
		id: '@atlassian/edition-benefits-modal.examples-section.illustration.ai-customer-service-forms-csm-team',
		defaultMessage: 'AI Customer Service Forms Illustration',
		description: 'Alt text for the AI customer service forms example image (csm teams)',
	},
});
